// import { TextField } from "@mui/material";
import { usersArray } from "assets/data/usersData";
// import { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardFilter, JoinedUser } from "ui";

const OnlineUsers = () => {
    const users = usersArray.slice(0, 5);

    // const [filter, setFilter] = useState("");

    return (
        <Card className="w-full h-full flex flex-col gap-5">
            <div className="flex flex-col justify-start items-start gap-2 dark:text-white">
                <h2 className="text-lg font-medium">Online Users</h2>
                <p>
                    <span className="font-medium">8</span> <span>Users</span>
                </p>
                <CardFilter
                    dropDownItems={[
                        "User ID",
                        "userName",
                        "Members Name",
                        "Country",
                        "Words"
                    ]}
                />
            </div>
            <div className="flex flex-col justify-start items-center gap-5 py-2 w-full h-full bg-neutral-50 dark:bg-momeento-100 rounded overflow-auto">
                {users.map((u) => (
                    <JoinedUser user={u} key={u.id} />
                ))}
            </div>
            <div className="w-full text-center">
                <Link
                    to="/users/online"
                    className="w-fit px-5 py-2 text-sm text-center bg-momeento-50 text-white hover:shadow-xl rounded-full"
                >
                    View More...
                </Link>
            </div>
        </Card>
    );
};

export default OnlineUsers;
